var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWindDirectionM(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z",
    transform: "translate(-300 -715) translate(285 704) translate(15 11)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#1E2447"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.307 0L0 2.002l5.307 2.002-.475-1.432h11.672l.978 1.264h5.797L21.86 2l.814-1.053.606-.784h-5.797l-.978 1.265H4.834L5.306 0zm12.468 1.081h.595L17.66 2l.71.918h-.595L17.065 2l.71-.919zm1.598 0h.595l-.71.919.71.918h-.595L18.663 2l.71-.919zm1.598 0h.594l-.71.919.71.918h-.594L20.261 2l.71-.919z",
    transform: "translate(-300 -715) translate(285 704) translate(15 11) translate(0 8.8)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M10.853 0.64H11.977V7.061999999999999H10.853z",
    transform: "translate(-300 -715) translate(285 704) translate(15 11) translate(0 8.8)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindDirectionM);
export default __webpack_public_path__ + "static/media/wind-direction-m.ba5a875f.svg";
export { ForwardRef as ReactComponent };